Watcher.observe('.js-slider-link', blocks => {
  blocks.forEach(block => {
    // In this block somewhere is an element with a data-columns attribute
    const wrap = block.querySelector('[data-columns]');

    // If there is no wrap, return
    if (!wrap) return;

    // Get the number of columns
    const columns = wrap.getAttribute('data-columns');
    // Create a new container element
    const container = document.createElement('div');
    // Find all the children of the wrap, and append them to the container
    while (wrap.firstChild) container.appendChild(wrap.firstChild);
    // Append the container to the wrap
    wrap.appendChild(container);

    // Set up a new tns slider
    const slider = tns({
      container,
      items: 1,
      controls: true,
      nav: true,
      navPosition: 'bottom',
      mouseDrag: true,
      rewind: true,
      mobileFirst: true,
      responsive: {
        768: {
          items: 2
        },
        1024: {
          items: columns
        }
      }
    });
  });
});